import React from "react";

const defaultSiaData = [
  {
    project: "",
    notificationNo: "",
    date: "",
    externalAgency: "",
    publicDomain: "",
    webLink: "",
  },
];

const SIATable = ({ siaData, setSiaData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...siaData];
    updated[index][field] = value;
    setSiaData(updated);
  };

  const addRow = () => {
    setSiaData([
      ...siaData,
      {
        project: "",
        notificationNo: "",
        date: "",
        externalAgency: "",
        publicDomain: "",
        webLink: "",
      },
    ]);
  };

  const removeRow = () => {
    if (siaData.length > 1) {
      setSiaData(siaData.slice(0, -1));
    }
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  return (
    <div>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={header}>Name and brief details of project</th>
              <th style={header}>SIA Notification No.</th>
              <th style={header}>Date of Notification</th>
              <th style={header}>
                Whether conducted by independent external agency (Yes / No)
              </th>
              <th style={header}>
                Results communicated in public domain (Yes / No)
              </th>
              <th style={header}>Relevant Web link</th>
            </tr>
          </thead>
          <tbody>
            {siaData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Name & Detail"
                    value={row.project}
                    onChange={(e) =>
                      handleChange(index, "project", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="No."
                    value={row.notificationNo}
                    onChange={(e) =>
                      handleChange(index, "notificationNo", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Date"
                    value={row.date}
                    onChange={(e) =>
                      handleChange(index, "date", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Yes / No"
                    value={row.externalAgency}
                    onChange={(e) =>
                      handleChange(index, "externalAgency", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Yes / No"
                    value={row.publicDomain}
                    onChange={(e) =>
                      handleChange(index, "publicDomain", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Link"
                    value={row.webLink}
                    onChange={(e) =>
                      handleChange(index, "webLink", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default SIATable;
